export default "__VITE_ASSET__D$oP0NhM__"